import {
    ArrowRightEndOnRectangleIcon,
    PencilIcon,
    PlayIcon,
    SparklesIcon,
    CommandLineIcon,
    CubeTransparentIcon,
    RocketLaunchIcon,
} from '../automationStudioIcons';

export const EMPTY_STATE_FEATURES = [
    {
        icon: SparklesIcon,
        title: 'AI-Powered Recording',
        description: 'Write instructions in plain English and let AI create test scripts for you',
    },
    {
        icon: CommandLineIcon,
        title: 'Visual Step Mapping',
        description: 'See how your instructions map to AI-generated test steps with collapsible hierarchy',
    },
    {
        icon: CubeTransparentIcon,
        title: 'Edit & Replay',
        description: 'Fine-tune selectors, customize steps, and replay tests—all in one place',
    },
    {
        icon: RocketLaunchIcon,
        title: 'Future Ready',
        description: 'Built for reusable functions, parameterization, and data-driven testing',
    },
];

export const AUTOMATION_STUDIO_EMPTY_CONTENT = {
    badge: 'AI-powered · Playwright · Live execution',
    title: 'Write instructions. AI does the rest.',
    description:
        'Describe your test in plain English on the left — no code needed. The AI generates Playwright steps and executes them live, and streams screenshots back to you in real time.',
    examplePanelTitle: 'TRY AN EXAMPLE — CLICK TO USE',
    startAutomationLabel: 'Start Automation',
};

export const AUTOMATION_STUDIO_LOGIN_EXAMPLE = {
    id: 'loginFlow',
    label: 'Login flow',
    icon: ArrowRightEndOnRectangleIcon,
    instructions: [
        { text: 'Navigate to qa-path.com' },
        { text: 'Login with dummy-example@gmail.com and password' },
    ],
};

export const AUTOMATION_STUDIO_EMPTY_FLOW_STEPS = [
    {
        id: 'writeSteps',
        title: 'Write steps',
        description: 'Plain English instructions',
        icon: PencilIcon,
    },
    {
        id: 'aiGenerates',
        title: 'AI generates',
        description: 'Playwright steps created',
        icon: SparklesIcon,
    },
    {
        id: 'liveExecution',
        title: 'Live execution',
        description: 'Runs in browser, live',
        icon: PlayIcon,
    },
];
